import { render, staticRenderFns } from "./CalendarDetailsComponent.vue?vue&type=template&id=5e5a7e75"
import script from "./CalendarDetailsComponent.vue?vue&type=script&lang=js"
export * from "./CalendarDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./CalendarDetailsComponent.vue?vue&type=style&index=0&id=5e5a7e75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
